import React, { useEffect, useState } from 'react';
import apiClient from '../../apiClient';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { UNVERIFIED_ASSET, UNVERIFIED_RESOURCE } from '../../apiClient/apiEndpoints';
import logo from '../../Static/images/logo.png';
import NoFiles from '../NoFiles';
import { SearchesCIcon } from '../../Static/icons/iconshere';


const UnPublishAssets = () => {
    const params = useParams();
    const { id } = params
    const navigate = useNavigate();
    const configData = useSelector((state) => state.configSlice);
    const userData = useSelector((state) => state.userSlice);
    const [fetchingLoading, setFetchingLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [list, setList] = useState([]);
  
      const getAssetUnverified = async () => {
      try {
        setFetchingLoading(true);
        let data = await apiClient.get(`${configData.config.UNO_URL}${UNVERIFIED_RESOURCE}/3dasset`)
        setList(data);
  
      } catch (error) {
        console.log(error);
      }finally{
        setFetchingLoading(false);
      }
    }
  
    useEffect(() => {
      getAssetUnverified()
    }, []);

  return (
    <>
        <div className='stuckhere'>
                <div className="row">
                    <div className="col-md-6">
                        <form className=" app-search app-search1 d-flex justify-content-start ">
                            <div className="position-relative">
                                <SearchesCIcon />
                                <input
                                    type="text"
                                    name="searchName"
                                    className="form-control"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Search "
                                    autoComplete="off"
                                />
                            </div>
                        </form>
                    </div>
                    <div className="col-md-6  d-flex align-items-center justify-content-end mainbtns"> </div>
                </div>

                <div className='row mt-4'> </div>
                
        </div>

        <div className='px-3 environments'>
              <>
                  {list.length > 0 &&
                      <div className='col-md-12 filesndfolders assets mt-4 px-2'>
                          <h3 className='mb-3'>Assets</h3>
                          {list.length > 0 ?
                            <div className='course-tiles'>
                                {list.map((e, i) => {
                                  if (search.length > 0 && !e.name.toLowerCase().includes(search.toLowerCase())) return null;
                                    return (
                                        <div className='tilecard' key={e.uuid} onClick={() => navigate(`/dashboard/3d/review/details/${e.uuid}`, {state: {actionMode: "REVIEW" , parentId: id} })} >
                                            <div className='assetsbox'>
                                                <div className='preview'>
                                                    <img src={e.thumbnail || logo}
                                                        onError={(e) => {
                                                            e.target.src = { logo };
                                                            e.onerror = null;
                                                        }}
                                                        alt='no-referrer'
                                                        referrerPolicy={'no-referrer'}
                                                    />
                                                </div>
                                                <div className='details'>
                                                    <Tooltip title={e.name}>
                                                        <p>{e.name}</p>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            :
                            <div className='No-Cat-Asset'>
                                <NoFiles message={"No Assets or Sub Categories Found"} />
                            </div>
                          }
                      </div>
                  }
              </>
        </div>

    </>
  )
}


export default UnPublishAssets;